const About = () => {
  const name = 'Hal Barnett';
  const todoDemoHref =
    process.env.NODE_ENV === 'production' ? '/todos' : 'http://localhost:5173/';
  return (
    <div>
      <h2 className="mb-4">About {name}</h2>
      <p>
        I&apos;m a self-starting software developer with a passion for building
        web applications and learning new technologies. I enjoy working with
        modern frameworks and libraries to create efficient and user-friendly
        experiences.
      </p>
      <dl>
        <dt>Todo list app:</dt>
        <dd>
          Uses React, TypeScript, Vite and Zustand (for state):&nbsp;
          <a
            href="https://github.com/otherblandart/todo-app"
            target="_blank"
            rel="noreferrer"
          >
            Github
          </a>
          &nbsp; | &nbsp;
          <a href={todoDemoHref} target="_blank" rel="noreferrer">
            Demo
          </a>
        </dd>
      </dl>
    </div>
  );
};

export default About;
